<template>
  <el-row>
    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix" style="border: none">
        <i class="el-icon-card-header"></i>
        <span>处方营业额</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_11.png"/>
              </el-col>
              <el-col :span="14">
                <el-row class="numClass" style=" color: #86F234;">
                  <CountTo :startVal="Number(feecf.cf_cnt || 0) / 2"
                           :endVal="Number(feecf.cf_cnt || 0)"
                           :duration="changeSlow"></CountTo>
                </el-row>
                <el-row :span="24" class="hintClass">处方</el-row>
              </el-col>
              <el-col :span="5" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #5DE9A8;">▲{{
                    feecf.cf_tongbi_ratio || ''
                  }}
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <LineChart id="clinic_chufang_cum11"
                         :area_color="'#86F234'"
                         height="120px"
                         width="100%"
                         :show_mode="'simple'"
                         path="clinic_chufang_cum"></LineChart>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_6.png"/>
              </el-col>
              <el-col :span="14">
                <el-row class="numClass" style=" color: #86F234;">
                  <CountTo :startVal="0.8 * Number(feecf.fee_amount || 0)"
                           :endVal="Number(feecf.fee_amount || 0)"
                           :duration="changeSlow"></CountTo>
                </el-row>
                <el-row :span="24" class="hintClass">营业额</el-row>
              </el-col>
              <el-col :span="5" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #5DE9A8;">▲{{
                    feecf.fee_tongbi_ratio || ''
                  }}
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <LineChart id="clinic_fee_cum11"
                         :area_color="'#86F234'"
                         height="120px"
                         width="100%"
                         :show_mode="'simple'"
                         path="clinic_fee_cum"></LineChart>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_5.png"/>
              </el-col>
              <el-col :span="14">
                <el-row class="numClass" style=" color: #86F234;">机构</el-row>
                <el-row :span="24" class="hintClass">营业额排名</el-row>
              </el-col>
              <el-col :span="5" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #86F234;font-size: 14px;line-height: 16px;">
                  {{ feecf.fee_shengqu_1 || '' }}
                </el-row>
                <el-row class="numClass-small" style="color: #86F234;font-size: 14px;line-height: 16px;">
                  {{ feecf.fee_shengqu_2 || '' }}
                </el-row>
                <el-row class="numClass-small" style="color: #86F234;font-size: 14px;line-height: 16px;">
                  {{ feecf.fee_shengqu_3 || '' }}
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <LineChart id="demo0011"
                         path="top_shengqu_fees"
                         height="120px"
                         width="100%"
                         :show_mode="'simple'"></LineChart>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_12.png"/>
              </el-col>
              <el-col :span="14">
                <el-row class="numClass" style=" color: #86F234;">诊所</el-row>
                <el-row :span="24" class="hintClass">营业额排名</el-row>
              </el-col>
              <el-col :span="5" style="margin-right: 0px;">
                <el-row class="numClass-small" style="color: rgb(93, 233, 168);font-size: 15px;line-height: 18px;" v-if="feecf.fee_clinic_1">
                  <a :href="'/#/clinic/clinic_info?doctor_id=-1&clinic_id='+feecf.fee_clinic_1.clinic_id"
                     target="_blank"
                     style="color:rgb(93, 233, 168)"
                     :title="feecf.fee_clinic_1.clinic_name">{{ feecf.fee_clinic_1.clinic_name.substr(0, 4) }}</a>
                </el-row>
                <el-row class="numClass-small" style="color: rgb(93, 233, 168);font-size: 15px;line-height: 18px;" v-if="feecf.fee_clinic_2">
                  <a :href="'/#/clinic/clinic_info?doctor_id=-1&clinic_id='+feecf.fee_clinic_2.clinic_id"
                     target="_blank"
                     style="color:rgb(93, 233, 168)"
                     :title="feecf.fee_clinic_2.clinic_name">{{ feecf.fee_clinic_2.clinic_name.substr(0, 4) }}</a>
                </el-row>
                <el-row class="numClass-small" style="color:rgb(93, 233, 168);font-size: 15px;line-height: 18px;" v-if="feecf.fee_clinic_3">
                  <a :href="'/#/clinic/clinic_info?doctor_id=-1&clinic_id='+feecf.fee_clinic_3.clinic_id"
                     target="_blank"
                     style="color:rgb(93, 233, 168)"
                     :title="feecf.fee_clinic_3.clinic_name">{{ feecf.fee_clinic_3.clinic_name.substr(0, 4) }}</a>
                </el-row>
              </el-col>
            </el-row>
            <el-row>
              <LineChart id="demo001111"
                         path="top_clinic_fees"
                         height="120px"
                         width="100%"
                         :show_mode="'simple'"></LineChart>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </el-row>
</template>

<script>
import LineChart from "@/views/charts/line";
import CountTo from "vue-count-to";

export default {
  name: "FeeCfReportSection",
  components: {
    LineChart,
    CountTo,
  },
  props: {
    // 处方营业额统计数据，保持与旧页面一致
    feecf: {
      type: Object,
      default: () => ({}),
    },
    // 计数动画时长，沿用原始业务逻辑
    changeSlow: {
      type: Number,
      default: 5000,
    },
  },
};
</script>

<style scoped src="./list.css"></style>
